import React from "react";
import { Box, Text } from "@chakra-ui/react";

export const PaymentRouteHelpTooltipContent: React.FC = () => (
  <Box textAlign="left">
    <Text>For Trading:</Text>
    <Text mb={1}>Case 1: Customer is a NBFC customer</Text>
    <Box as="ul" pl={4} m={0} mb={2}>
      <Box as="li">NBFC → Garaaz</Box>
    </Box>
    <Text mb={1}>Case 2: Customer is not a NBFC customer</Text>
    <Box as="ul" pl={4} m={0} mb={2}>
      <Box as="li">Customer → Garaaz</Box>
    </Box>
    <Text mt={2}>For Facilitation:</Text>
    <Text mb={1}>Case 1: Customer has a credit relationship with the supplier</Text>
    <Box as="ul" pl={4} m={0} mb={2}>
      <Box as="li">Customer → Supplier</Box>
    </Box>
    <Text mb={1}>Case 2: Customer is a NBFC customer and has no credit relationship with the supplier</Text>
    <Box as="ul" pl={4} m={0} mb={2}>
      <Box as="li">NBFC → Garaaz</Box>
    </Box>
    <Text mb={1}>Case 3: Customer is not a NBFC customer</Text>
    <Box as="ul" pl={4} m={0}>
      <Box as="li">Customer → Garaaz</Box>
    </Box>
  </Box>
);
